import * as React from 'react';
import { FormControl, FormHelperText, TextField } from '@mui/material';
import useUnique from '../hooks/useUnique';

export interface ValidTextFieldProps {
  placeholder?: string;
  disabled: boolean;
  initValue: string;
  names: string[];
  apiDuplicated: boolean;
  setApiDuplicated: (duplicated: boolean) => void;
  checkApiDuplicated: (value: string) => void;
  setSubmitDisabled: (disabled: boolean) => void;
  style?: any;
  cypressId?: string;
  onKeyPress?: (event: React.KeyboardEvent) => void;
}

// TODO: use react form for validation
const ValidTextField: React.FC<ValidTextFieldProps> = ({
  placeholder,
  disabled,
  initValue,
  names,
  apiDuplicated,
  setApiDuplicated,
  checkApiDuplicated,
  setSubmitDisabled,
  style,
  cypressId,
  onKeyPress,
}) => {
  const [value, setValue] = React.useState(initValue);
  const [dirty, setDirty] = React.useState(false);
  const errorMessage = useUnique(names, value, dirty, apiDuplicated);

  React.useEffect(() => {
    if (errorMessage.length > 0) {
      setSubmitDisabled(true);
    } else {
      setSubmitDisabled(false);
    }
  }, [errorMessage, setSubmitDisabled]);
  // TODO: would this be slow while user typing and checking the api?
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setValue(e.target.value);
    setDirty(true);
    setApiDuplicated(false);
    checkApiDuplicated(e.target.value);
  };

  return (
    <FormControl style={style}>
      <TextField
        autoFocus
        fullWidth
        autoComplete="off"
        variant="outlined"
        size="small"
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={handleOnChange}
        onKeyPress={onKeyPress}
        inputProps={{ 'data-cy': cypressId ? cypressId : '' }}
        //onBlur={handleOnBlur}
      />
      {errorMessage.length > 0 && (
        <FormHelperText id="label-field-error" data-cy="label-field-error" style={{ color: 'red' }}>
          {errorMessage}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default ValidTextField;
